import { Link, NavLink, Outlet } from '@remix-run/react'

import { MarketingFooter } from '~/components/marketing/MarketingFooter'
import { AppLogo } from '~/components/ui/navigation/AppLogo'
import { useOptionalUser } from '~/utils'

const NAV: { to: string; label: string; blurb: string }[] = [
  { to: '/docs', label: 'Overview', blurb: 'Concepts, keys, quickstart' },
  { to: '/docs/api', label: 'REST API', blurb: 'Key-authed HTTP endpoints' },
  { to: '/docs/cli', label: 'CLI', blurb: 'The quiver command' },
  { to: '/docs/mcp', label: 'MCP', blurb: 'Connect any AI client' },
]

export default function DocsLayout() {
  const user = useOptionalUser()
  return (
    <main className="min-h-screen bg-[#0b0c0e] text-zinc-100 antialiased">
      <div aria-hidden="true" className="fixed inset-0 -z-10 bg-[#0b0c0e]" />
      <header className="sticky top-0 z-40 border-b border-white/10 bg-[#0b0c0e]/80 backdrop-blur">
        <div className="mx-auto flex max-w-5xl items-center justify-between px-6 py-4">
          <div className="flex items-center gap-3">
            <Link to="/" aria-label="Tell Quiver home">
              <AppLogo size="sm" className="text-white" />
            </Link>
            <span className="text-sm font-medium text-zinc-500">Docs</span>
          </div>
          <nav className="flex items-center gap-2 text-sm">
            <Link to="/" className="hidden px-3 py-2 font-medium text-zinc-400 transition-colors hover:text-white sm:inline">
              Home
            </Link>
            <Link
              to={user ? '/app' : '/join'}
              className="rounded-md bg-indigo-500 px-4 py-2 font-medium text-white shadow-sm transition-colors hover:bg-indigo-400"
            >
              {user ? 'Open dashboard' : 'Get started'}
            </Link>
          </nav>
        </div>
      </header>

      <div className="mx-auto grid max-w-5xl gap-10 px-6 py-12 lg:grid-cols-[200px_1fr]">
        {/* Sidebar */}
        <aside className="lg:sticky lg:top-24 lg:h-fit">
          <nav className="flex flex-row flex-wrap gap-2 lg:flex-col">
            {NAV.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                end={n.to === '/docs'}
                className={({ isActive }) =>
                  `rounded-lg border px-3 py-2 transition-colors ${
                    isActive
                      ? 'border-indigo-400/30 bg-indigo-500/[0.08] text-white'
                      : 'border-white/10 text-zinc-300 hover:bg-white/[0.04] hover:text-white'
                  }`
                }
              >
                <div className="text-sm font-semibold">{n.label}</div>
                <div className="hidden text-[11px] text-zinc-500 lg:block">{n.blurb}</div>
              </NavLink>
            ))}
          </nav>
        </aside>

        {/* Content */}
        <div className="min-w-0 space-y-14">
          <Outlet />
        </div>
      </div>

      <MarketingFooter />
    </main>
  )
}
